module.exports = "/_next/static/images/permata-logo-3d44d4592dec7c5e8c9ff301b5e63f8f.svg";